import { SVGProps } from 'react';
const SvgOption = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 7h5.434a1 1 0 0 1 .857.486l5.418 9.029a1 1 0 0 0 .857.485H21M15 7h6"
    />
  </svg>
);
export default SvgOption;
